import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type vatRatesSlice = CommonTableState;

const initialState: vatRatesSlice = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnOrder: ["rateType", "rate", "validFrom", "validTo"],
        density: "compact",
    },
};

export const vatRatesSlice = createSlice({
    name: "vatRates",
    initialState: initialState,
    reducers: {
        updateVatRatesTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateVatRatesTableState } = vatRatesSlice.actions;

export default vatRatesSlice.reducer;
